import React, { useState, useRef, useEffect, useContext } from 'react'
import { Tree, getBackendOptions } from "@minoru/react-dnd-treeview";
import axios from 'axios'
import { useNavigate } from "react-router-dom";
import qs from 'qs';
import * as CryptoJS from 'crypto-js'
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom'
import SweetAlert from "react-bootstrap-sweetalert";
import {properties} from "../../utils/properties";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { Fab, Tooltip } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import CircularProgress from '@mui/material/CircularProgress';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { NativeTypes } from "react-dnd-html5-backend";
import FileNode from "../TreeViewSection/FileNodeCollegio"
import RouterContext from "../../context/RouterContext";

import {
  getPathWithParentId,
  convertResToFilesTree,
  getOperationParams
} from "../../utils/utils"

import '../../assets/bootstrap-custom.css';
import "../TreeViewSection/sessionManagerStyles.css";
import dayjs from 'dayjs';
import 'dayjs/locale/it';

export default function FileManager3() {
  const { pageRouter, setPageRouter } = useContext(RouterContext);
  const [alert, setAlert] = useState(null);
  const treeRef = useRef(null);  
  const navigate = useNavigate();
  const [treeData, setTreeData] = useState([]);
  const [lockedFile, setLockedFile] = useState(false);
  const [inProgress, setInProgress] = useState(false);
  let {idMeeting } = useParams();

  const [inputText, setInputText] = useState("");

  
  const showAlertText = (text) => {
    let value="Collegio Sindacale: La seduta del "+idMeeting.replaceAll("-","/") + " è stata aggiornata con nuovi documenti. ";    
    console.log("showing alert for text",idMeeting);

    setAlert(
      <SweetAlert
      //input
      title="Inserire il testo della notifica che verrà inviata a tutti gli utenti dell'app"          
      
      onConfirm = {() => {        
        console.log("Testo finale1:", value);
        setInProgress(true);
        handlePublishing(idMeeting);  
        doPostAPNS(value);
        setAlert(null);
        }
      }      
      onCancel={() => setAlert(null)}
      confirmBtnText="Pubblica e Invia"
      cancelBtnText="Annulla"
      showCancel
      style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}      
      confirmBtnCssClass="custom-btn custom-btn-success"
      cancelBtnCssClass="custom-btn custom-btn-cancel"
    >
        <p>Gli aggiornamenti verranno resi pubblici e, subito dopo, verrà inviata una notifica a tutti gli utenti con il testo seguente:</p>
        <textarea            
            defaultValue={value}
            onChange={(e) => {
              //console.log(e.target.value);              
              value=e.target.value;
            }}
            
            style={{
              width: "100%", 
              height: "150px", 
              fontSize: "18px", 
              padding: "12px", 
              resize: "none", 
              boxSizing: "border-box", 
              marginTop: "20px", 
            }}
          />  
    </SweetAlert>
  
    );
};

  const handleOpenAll4 = (id) => {
    if( properties.verboseLog==1)
      console.log("HOA4",id);
    treeRef.current.open(id);   
  };

  
  const doPostAPNS = function( text) {
    if( properties.verboseLog==1)
      console.log("doPostAPNS", text);
    
      console.log("CALLED FETCHLAST");
      const operationName = "getLastIssue"
  
      const operationParams = {
        message: btoa(text)
      };
     
  
      //let endpoint = properties.productionUrl+properties.productionUrlSuffix +'/core/test_apns.php';  
      let endpoint = properties.productionUrl+properties.productionUrlSuffix +'/core/apns_collegio.php';  
      axios({
        method: 'post',
        url: endpoint,
        data: operationParams, 
        withCredentials: true, 
        headers: {'Content-Type': 'multipart/form-data' }
      })
      .then(res => {
          if( properties.verboseLog==1){
            console.log("FLI",res);                        
          }                    
          //navigate("/files/"+a[0]+"-"+a[1]+"-"+a[2],{ replace: true });   
        })
        .catch(err => {
          console.log(err)
        })            
}

  /******* Get Last Issue Begin ********/
  const fetchLastIssue = () => {
    const operationName = "getLastIssue"
    const operationParams = {
      app_user: "app",
      app_password: "meeting",
      operation: operationName
    };
       
    let endpoint = properties.productionUrl+properties.productionUrlSuffix +"/core/issueManagerCollegio.php";  
    axios({
      method: 'post',
      url: endpoint,
      data: operationParams, 
      withCredentials: true, 
      headers: {'Content-Type': 'multipart/form-data' }
    })
    .then(res => {
        if( properties.verboseLog==1)
          console.log("FLI",res)
        setTreeData(convertResToFilesTree(res.data.dirTree));
        setLockedFile(res.data.lockedForFileInsert);
        if(res.data.lockedForFileInsert==false)
          showAlert();
        //treeRef.current.openAll();        
        var a=res.data.formattedConvocationDate.split("/");        
        if(a[0].length==1)
          a[0]="0"+a[0];
        if (a[1].length==1)
          a[1]="0"+a[1];
        if( properties.verboseLog==1)
          console.log(a);        
        navigate("/files3/"+a[0]+"-"+a[1]+"-"+a[2],{ replace: true });   
      })
      .catch(err => {
        console.log(err)
      })
  }
  /******* Get Last Issue End ********/

  const handleIssueExistsStartingFromDateLabel = (selectedDate) => {    
    const issueName = 'Seduta del '+ selectedDate;    
    handleLoadIssue(issueName)          
  }

  const showAlert = () => {
    setAlert(
      <SweetAlert
      warning
      style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
      title="La seduta non è ancora stata resa pubblica, pertanto, non è ancora possibile caricare documenti. Tornare alla gestione delle sedute?"      
      onConfirm={() => navigate("/folders3")}      
      confirmBtnCssClass="custom-btn custom-btn-success" 
      confirmBtnText="Si"
      >
      </SweetAlert>
    );
  };

  const handleLoadIssue = (issueName) => {
    const operationName = "loadIssue";
    if( properties.verboseLog==1){
      console.log("HandleLoadIssue", issueName);
      console.log("handleIssue-1", issueName.length, issueName);
    }
    const params = null;
    const operationParams = {
      app_user: "app",
      app_password: "meeting",
      operation: operationName,
      issueName: issueName,
      params: JSON.stringify(params)
    };
    
    let endpoint = properties.productionUrl+properties.productionUrlSuffix +"/core/issueManagerCollegio.php";  
    axios({
      method: 'post',
      url: endpoint,
      data: operationParams, 
      withCredentials: true, 
      headers: {'Content-Type': 'multipart/form-data' }
    })
      .then(res => {
        if( properties.verboseLog==1){
          console.log("HANDLELOADISSUE",res);
          console.log("TEST",res.data.result);      
        }
        setTreeData(convertResToFilesTree(res.data.result.dirTree));
        setLockedFile(res.data.result.lockedForFileInsert);
        if( properties.verboseLog==1)
          console.log("2",res.data.result.lockedForFileInsert);
        if(res.data.result.lockedForFileInsert==false){
          if( properties.verboseLog==1)
            console.log("3",res.data.result.lockedForFileInsert);
          showAlert();
        }        
        treeRef.current.openAll();
      })
      .catch(() => {
        toast.error("Failed to load issue")
      })
  }

  /*********** Add File Begin *************/
  const handleAddFile = (fileName, fileType, base64, md5hash, parentId) => {
    setInProgress(true);
    let paramClass = ''
    if( properties.verboseLog==1)
      console.log("a1",fileType);
    switch (fileType) {
      case 'application/pdf':
        paramClass = 'filetypepdf'
        break;
      case 'application/msword':
        paramClass = 'filetypeword'
        break;
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        paramClass = 'filetypeword'
        break;
      case 'image/jpeg':
        paramClass = 'filetypeimg'
        break;
      case 'image/png':
        paramClass = 'filetypeimg'
        break;
      default:
        break;
    }

    const params = {
      "data": base64,
      "md5Hash": md5hash,
      "encoding": "base64",
      "childName": fileName,
      "path": getPathWithParentId(treeData, parentId),
      "attr": {
        "id": "newbornfile",
        "rel": "file",
        "class": paramClass,
        "flabel": "file",
        "ftype": fileType,
        "custom": "[]"
      },
      "pos": 0
    };
    const _issueName = treeData.find(node => node.id === 1).text    
    const operationParams = getOperationParams("addFile", _issueName, params)    
    let endpoint = properties.productionUrl+properties.productionUrlSuffix +"/core/fileManagerCollegio.php";                                     
    axios({
          method: 'post',
          url: endpoint,
          data: operationParams, 
          withCredentials: true, 
          headers: {'Content-Type': 'multipart/form-data' }
      })
      .then(res => {
        if( properties.verboseLog==1)
          console.log(res)
        setTreeData(convertResToFilesTree(res.data.result.updatedIssue.dirTree))
        treeRef.current.openAll();
        setInProgress(false);
        handleOpenAll4(parentId); 
      })
      .catch(err => {
        console.log(err)
        setInProgress(false)
        toast.error("Failed to add file")
      })
  }
  /*********** Add File End *************/

  const handlePublishing = (issueName) => {
    if( properties.verboseLog==1)
      console.log("handlePublishing", issueName);                           
    let endpoint = properties.productionUrl+properties.productionUrlSuffix +"/core/rest/goPub3.php";  
    var bodyFormData=new FormData();              
    bodyFormData.append('issueName', 'Seduta del '+issueName);    
    axios({
        method: 'post',
        url: endpoint,
        data: bodyFormData, 
        withCredentials: true, 
        headers: {'Content-Type': 'multipart/form-data' }
    })
    .then(function (response) {
      localStorage.removeItem("meeting");
      localStorage.removeItem("meetingContent");
      localStorage.removeItem("meetingVersion");
      setAlert(
        <SweetAlert
        success
        style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
        title="Tutti i file caricati sono stati resi pubblici. Gli autorizzati possono ora accedere al materiale"      
        onConfirm={() => setAlert(null)}           
        onCancel={() => setAlert(null)}      
        showConfirm={false}    
        >
        </SweetAlert>
      );
      setInProgress(false);        
    })
    .catch(function (response) {            
        toast.error("Si è verificato un errore pubblicando la seduta!");
        setInProgress(false);        
    });
  }
  
  const onFabClick= (e ) => {           
    //if( properties.verboseLog==1)
      console.log("OFC",e,idMeeting);        
    setInProgress(true);
    handlePublishing(idMeeting);          
  };

  /********** Delete File Begin **********/
  const handleDeleteFile = (id) => {
    const params = {
      "path": treeData.find(tree => tree.id === id).realPath,
      "childName": treeData.find(node => node.id === id).text,
      "isFile": true
    }
    const _issueName = treeData.find(node => node.id === 1).text
    const operationParams = getOperationParams("deleteFile", _issueName, params)    
    let endpoint = properties.productionUrl+properties.productionUrlSuffix +"/core/fileManagerCollegio.php";                                     
    axios({
          method: 'post',
          url: endpoint,
          data: operationParams, 
          withCredentials: true, 
          headers: {'Content-Type': 'multipart/form-data' }
      })
      .then(res => {
        if( properties.verboseLog==1)
          console.log(res)
        setTreeData(convertResToFilesTree(res.data.result.dirTree))
      })
      .catch(() => {
        toast.error("Failed to delete")
      })
  }
  /********** Delete File End **********/

  /************* Rename File Begin **************/
  const handleRenameFile = (id, newName) => {
    const params = {
      "path": treeData.find(tree => tree.id === id).realPath,
      "oldName": treeData.find(node => node.id === id).text,
      "newName": newName,
      "isFile": true
    };
    const _issueName = treeData.find(node => node.id === 1).text    
    const operationParams = getOperationParams("renameFile", _issueName, params)    
    let endpoint = properties.productionUrl+properties.productionUrlSuffix +"/core/fileManagerCollegio.php";                                     
    axios({
          method: 'post',
          url: endpoint,
          data: operationParams, 
          withCredentials: true, 
          headers: {'Content-Type': 'multipart/form-data' }
      })
      .then(res => {
        if( properties.verboseLog==1)
          console.log(res)
        if (res.data.status === 'ok') {
          const updatedTreeData = treeData.map(node => {
            if (node.id === id) {
              return {
                ...node,
                id: res.data.result.newId,
                text: newName
              };
            } else {
              return {
                ...node
              }
            }
          })
          setTreeData(updatedTreeData);
        } else {
          toast.error("Failed to update")
          fetchLastIssue()
        }
      })
      .catch(err => {
        console.log(err)
        toast.error("Failed to update")
      })
  }
  /************* Rename File End **************/

  /*********** Move File Begin ***********/  
    const handleMoveFile = (newTree, options) => {    
      const { dropTargetId, monitor,dragSourceId } = options;
      var targetNode = treeData.find(node => node.id === dropTargetId)
      if( properties.verboseLog==1)
        console.log("HMF1111",targetNode,newTree,options, dropTargetId, monitor,dragSourceId );

      const itemType = monitor.getItemType();
      if( properties.verboseLog==1)
        console.log("HMF1112", itemType);
      if (itemType === NativeTypes.FILE) {     
        if( properties.verboseLog==1)
          console.log("IF HMF1112", itemType); 
        const acceptedFiles = monitor.getItem().files;        
        setInProgress(true);
        const fileName = acceptedFiles[0].name
        const fileType = acceptedFiles[0].type
        const reader = new FileReader()
        reader.readAsArrayBuffer(acceptedFiles[0]);
        reader.onload = () => {
          var wordArray = CryptoJS.lib.WordArray.create(reader.result);
          var md5 = CryptoJS.MD5(wordArray).toString();
          var base64 = CryptoJS.enc.Base64.stringify(wordArray); 
          handleAddFile(fileName, fileType, base64, md5, targetNode.id);
        }      
        if( properties.verboseLog==1)
          console.log("HMF1113",acceptedFiles);  
      }
      else{
        if( properties.verboseLog==1)
            console.log("ELSE HMF1112", itemType);
          var sourceNode =undefined;
          var sourceName =undefined;
          var sourceRealPath=undefined;
          if( dragSourceId != undefined) {
            sourceNode= treeData.find(node => node.id === dragSourceId)
            sourceRealPath=sourceNode.realPath;
            sourceName=sourceNode.text;
          }
          if( properties.verboseLog==1){
            console.log("TARGET:",targetNode);
            console.log("SOURCE:",sourceNode);
          }
          if (sourceNode!= undefined && sourceNode.data.isFolder) {
            return;
          }
          const params = {
            "frompath": sourceRealPath,
            "topath": `${targetNode.realPath}${targetNode.realPath !== '' ? '/' : ''}${targetNode.text}`,
            "nodeName": sourceName,
            "position": 0,
            "isFile": true
          }
          const issueName = treeData.find(node => node.id === 1).text
          if( properties.verboseLog==1)
            console.log("QUI 32",issueName,treeData[0].text,treeData);
          const operationParams = getOperationParams("moveFile", issueName, params)          
          let endpoint = properties.productionUrl+properties.productionUrlSuffix +"/core/fileManagerCollegio.php";                                     
          axios({
                method: 'post',
                url: endpoint,
                data: operationParams, 
                withCredentials: true, 
                headers: {'Content-Type': 'multipart/form-data' }
            })
            .then(res => {
              if( properties.verboseLog==1)
                console.log(res)
              if (res.data.status === 'ok') {
                const _newTree = newTree.map(node => {
                  if (node.id === dragSourceId) {
                    return {
                      ...node,
                      id: res.data.result.newNode.attr.id,
                      realPath: getPathWithParentId(newTree, node.parent),
                    };
                  } else {
                    return node
                  }
                })
                setTreeData(_newTree)
              } else {
                toast.error("Error occured!")
              }
            })
            .catch(err => {
              console.log(err)
              toast.error("Error occured!")
            })  
        }
  }
  /*********** Move File Begin ***********/

  /*********** Move position ************/
  const handleMove = (direction, id) => {
    if( properties.verboseLog==1)
      console.log("HM7777",direction,id);
    const sourceNode = treeData.find(node => node.id === id)
    const pos = treeData.filter(node => node.parent === sourceNode.parent).findIndex(node => node.id === id)
    if( properties.verboseLog==1){
      console.log("init", id, treeData,sourceNode,pos)
      console.log("init2",treeData.filter(node => node.parent === sourceNode.parent))
      console.log("init3",treeData.filter(node => node.parent === sourceNode.parent).length)
    }
    if ((pos === 0 && direction === 'up') || (direction === 'down' && pos === (treeData.filter(node => node.parent === sourceNode.parent).length - 1))) {      
      if( properties.verboseLog==1)
        console.log("inside",treeData.filter(node => node.parent === sourceNode.parent));
      return;
    }    
    const params = {
      "frompath": sourceNode.realPath,
      "topath": sourceNode.realPath,
      "nodeName": sourceNode.text,
      "position": direction === 'up' ? pos - 1 : pos + 1,
      "isFile": true
    }
    const _issueName = treeData.find(node => node.id === 1).text
    const operationParams = {
      app_user: "app",
      app_password: "meeting",
      operation: "moveFile",     
      issueName: _issueName,
      params: JSON.stringify(params)
    };
    if( properties.verboseLog==1)    
      console.log("HM7777_1",operationParams);
    
    let endpoint = properties.productionUrl+properties.productionUrlSuffix +"/core/fileManagerCollegio.php";                                     
    axios({
          method: 'post',
          url: endpoint,
          data: operationParams, 
          withCredentials: true, 
          headers: {'Content-Type': 'multipart/form-data' }
      })
      .then(res => {       
        if (res.data.result.status === 'ok') {
          fetchLastIssue()
        } else {
          toast.error('Failed to move')
        }
      })
      .catch(() => {
        toast.error('Failed to move')
      })
  }
  if( properties.verboseLog==1)
    console.log(treeData)

  useEffect(() => {
    if( properties.verboseLog==1)
      console.log ("2");
    //CHECK AUTHENTICATION
    var xhr = new XMLHttpRequest();                  
    xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/ping.php',true);
    xhr.withCredentials = true;
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

    xhr.onload = function (e) {
        if (xhr.readyState === 4) {
            if (xhr.status === 200) { 
                if( properties.verboseLog==1)                   
                  console.log("OK",xhr);              
            } else {                
                console.error("Error 1", xhr);        
                localStorage.clear();                                     
                navigate("/login");
            }
        }
    };
    xhr.onerror = function (e) {
      console.error("Error 2", xhr);
      localStorage.clear();
      navigate("/login");
    };
        
    let urlEncodedData = null; 
    xhr.send(urlEncodedData);
    //CHECK AUTHENTICATION
  
    if(idMeeting!=undefined){
      if(idMeeting=="last"){
        if( properties.verboseLog==1)
          console.log("if",idMeeting);     
        fetchLastIssue();
      }
      else {        
          if(idMeeting.length==10){
            if( properties.verboseLog==1)
              console.log("elseif",idMeeting);            
            handleIssueExistsStartingFromDateLabel(idMeeting);
        }    
        else{
          if( properties.verboseLog==1)
            console.log("elseelse",idMeeting);
          fetchLastIssue();
        }
      }
    }
    else{
      if( properties.verboseLog==1)
        console.log("altro else",idMeeting);
      fetchLastIssue();
    }
  }, []);

  return (    
    <div>
    {lockedFile ?(
    <div className="content">      
    <Tooltip title="Rendi Pubblico" placement="left">
    <Fab aria-label="add"                 
                //variant="contained" 
                onClick={(event) => {onFabClick(event) }}                
                style={{
                    margin: 0,
                    background: "#666999",
                    top: 'auto',
                    right: 10,
                    bottom: 25,
                    //color: '0xFF0000',
                    left: 'auto',
                    position: 'fixed',}}>                    
                    <SendIcon />                    
    </Fab>          
    </Tooltip>
    <Tooltip title="Rendi Pubblico ed invia una Notifica" placement="left">
    <Fab aria-label="add"                                 
                onClick={(event) => {showAlertText(event) }}                
                style={{
                    margin: 0,
                    background: "#666999",
                    top: 'auto',
                    right: 10,
                    bottom: 90,                    
                    left: 'auto',
                    position: 'fixed',}}>                    
                    <SendIcon />  
                    <Box
        component="span"
        style={{
          position: "absolute",
          top: "5px", // Sposta l'icona più in alto
          right: "5px", // Allinea leggermente a destra
        }}
      >
        <NotificationsActiveIcon style={{ transform: "scale(0.7)", position: "relative", top: "-3px", right:"3px" }}/>
      </Box>
                    
    </Fab>          
    </Tooltip>
      <Container maxWidth="xl">
        <Grid container spacing={2}  >
          <Grid item xs={12}  >
            <Box my={3}>
              <Typography variant="body1" style={{textAlign: "left",fontWeight: "bold", paddingBottom:"0px"}}>
                Per caricare i contenuti dellla seduta, aggiungi i file transcinadoli direttamente nelle cartelle:
              </Typography>
            </Box>
                    
            <Box style={{backgroundColor:"white", paddingTop:"10px", paddingLeft:"20px", borderRadius: "4px", border: "1px solid rgb(196,196,196)",}}>
              <DndProvider backend={HTML5Backend} options={getBackendOptions()}>
              <Tree
                ref={treeRef}
                tree={treeData}
                rootId={0}
                extraAcceptTypes={[NativeTypes.FILE]}
                initialOpen={true}
                insertDroppableFirst={false}
                sort={false}
                render={(node, options) => (
                  <FileNode
                    node={node}
                    {...options}
                    handleDeleteFile={handleDeleteFile}
                    handleAddFile={handleAddFile}
                    handleRenameFile={handleRenameFile}
                    //showProgress={() => setInProgress(true)}
                    handleMove={handleMove}
                  />
                )}             
          
                onDrop={handleMoveFile}
                classes={{
                  root: "treeRoot",
                  draggingSource: "draggingSource",
                  dropTarget: "dropTarget"
                }}
              />
              </DndProvider>
            </Box>
          </Grid>
        </Grid>
        {
          inProgress && (
            <Box className="processing">
              <CircularProgress className="circular" color="secondary" />
            </Box>
          )
        }
      </Container>
    </div>
    ):(   
      <></>
      )}
       <div>
      {alert}        
      </div>
    </div>
  )
}